module.exports = __webpack_public_path__ + "img/xnr1.e18addad.jpg";